import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

import { PageLoading } from "@/components/shared/loading";

const InvoiceGateBatchPage = lazy(() => import("@/features/invoice-gate/pages/invoice-gate-batch"));

export const Route = createFileRoute("/(app)/dashboard/invoice-gate/batch")({
  component: () => (
    <Suspense fallback={<PageLoading />}>
      <InvoiceGateBatchPage />
    </Suspense>
  ),
});
